<template>
  <div class="bread_crumb">
    <div class="bread_crumb_inner">
      <a href="" class="home">홈</a>
      <a href="">마이페이지</a>
      <a>나의상품평</a>
    </div>
  </div>
  <main id="main">
    <div class="contents">
      <div class="mypage_wrap">
        <MyHeader />
        <div class="mypage_body">
          <MySideBar />
          <MyReviewForm />
        </div>
      </div>
    </div>
  </main>
  <MainSideBar />
</template>
<script>
import MainSideBar from "../../layout/navigation/MainSideBar.vue";
import MyHeader from "../layout/MyHeader.vue";
import MySideBar from "../layout/MySideBar.vue";
import MyReviewForm from "@/components/mypage/activityLog/MyReviewForm.vue";

export default {
  components: {
    MainSideBar,
    MyHeader,
    MySideBar,
    MyReviewForm
  },
};
</script>
<style lang=""></style>
